import React, { useEffect, useState } from "react";
import { Content, Col, Box, Button } from "adminlte-2-react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment-timezone";
import "react-big-calendar/lib/css/react-big-calendar.css";
import _ from "lodash";
import controller from "../reservas/duck";
import controllerLocal from "../locales/duck";
import { useSelector, useDispatch } from "react-redux";
import LoaderCalendario from "../utils/LoaderCalendario";
import { parseJwt } from "../utils/utils";
import SelectInput from "../utils/SelectInput";

require("moment/locale/es.js");

const localizer = momentLocalizer(moment);

const conceptoAPintarOptions = [
  { value: "profesional", label: "Profesionales" },
  { value: "servicio", label: "Servicios" },
];

function Calendario({ history, match }) {
  const dispatch = useDispatch();

  const modelEventos = useSelector((state) => state.reservasConfirmadasByLocal);
  const modelLocal = useSelector((state) => state.localById);
  const modelHorarios = useSelector((state) => state.horariosEntreFechas);
  const modelAmbientes = useSelector((state) => state.getAmbientes);
  const [eventos, setEventos] = useState([]);
  const [eventosDisponibles, setEventosDisponibles] = useState([]);
  const [local, setLocal] = useState(null);
  const [actualRol, setActualRol] = useState(null);
  const [inicio, setInicio] = useState(null);
  const [fin, setFin] = useState(null);
  const [serviciosPadreOptions, setServiciosPadreOptions] = useState([]);
  const [serviciosOptions, setServiciosOptions] = useState([]);
  const [servicio, setServicio] = useState(null);
  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [profesional, setProfesional] = useState(null);
  const [servicioPadre, setServicioPadre] = useState(null);
  const [currentSubcategoria, setCurrentSubcategoria] = useState(null);
  const [currentServicio, setCurrentServicio] = useState(null);
  const [currentProfesional, setCurrentProfesional] = useState(null);
  const [conceptoPintar, setConceptoPintar] = useState("profesional");
  const [copyIcon, setCopyIcon] = useState("📋 Copiar URL para feed");


  const sumarMinutos = (horaIncial, suma) => {
    const hora = moment(horaIncial, "YYYY-MM-DD HH:mm")
      .add(suma, "minutes")
      .format("YYYY-MM-DD HH:mm");
    return hora;
  };

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
    if (data && data.data) {
      setLocal(data.data);

      const subcategoriaOptions = data.data.subCategorias.map((row) => {
        if (row.estado === "ACTIVO") {
          return {
            label: row.nombre,
            value: row.id,
          };
        }
      });
      setServiciosPadreOptions(subcategoriaOptions);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    if (servicioPadre) {
      const hijos = local.servicios.filter(
        (elem) => elem.subCategoriaId === servicioPadre
      );
      const servicioOpciones = hijos.map((row) => {
        if (row.estado === "ACTIVO") {
          return {
            label: row.nombre,
            value: row.id,
            ...row,
          };
        }
      });
      setServiciosOptions(servicioOpciones);
      setServicio(null);
      setProfesional(null);
    }
  }, [servicioPadre]);

  useEffect(() => {
    if (servicio) {
      if (local && local.categoriaId !== "60f806a5e3e9af972fe85c7a") {
        const servicioSelected = serviciosOptions.filter(
          (elem) => elem.id === servicio
        );
        const idProfesionales = servicioSelected[0].profesionales;
        const arrayprofesionales = [];
        idProfesionales.forEach((row) => {
          const reg = local.profesionales[row];
          if (reg && reg.estado === "ACTIVO") {
            reg.value = reg.id;
            reg.label = reg.nombre;
            arrayprofesionales.push(reg);
          }
        });
        setProfesionalesOptions(arrayprofesionales);
        setProfesional(null);
      }
    }
  }, [servicio]);

  useEffect(() => {
    if (profesional) {
    }
  }, [profesional]);

  useEffect(() => {
    const data = modelEventos?.data?.data;
    const error = modelEventos?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.reservasConfirmadasByLocalDuck.actions.clear());
    }
    if (data) {
      const result = data.data.map((row) => {
        const final = row.duracion
          ? sumarMinutos(moment(row.fecha), row.duracion)
          : row.fecha;

        const origen = row?.detalles?.origen ? row?.detalles?.origen : "ADMIN";

        const title = row?.detalles?.profesionalNombre
          ? `${row.hora} - ${row.detalles.nombre} - ${row.detalles.servicioNombre} - ${row.detalles.profesionalNombre} - ${origen}`
          : `${row.detalles.nombre} - ${row.detalles.servicioNombre} - ${row.detalles.ambienteNombre} - ${row.detalles.validoPara} personas - ${origen}`;

        const reg = {
          title,
          start: moment(row.fecha).utc().toDate(),
          end: moment(final).utc().toDate(),
          allDay: row?.detalles?.profesionalNombre ? false : true,
          resource: row,
        };

        return reg;
      });

      setEventos(result);

      dispatch(controller.reservasConfirmadasByLocalDuck.actions.clear());
    }
  }, [modelEventos]);

  // mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return history.push("/logout");
    }

    const decodedToken = parseJwt(token);

    setActualRol(decodedToken.rol);

    // Al cargar el calendario, la vista por defecto es el mes.
    // El último día que muestra es el primer domingo a partir del
    // último día del mes actual.
    // Se consulta a backend reservas hasta esa fecha.
    // Otros métodos para traer última fecha mostrada
    // (al cargar el calendario)
    // no funcionaron.

    const primerDiaMostrado = getFirstMondayBeforeFDOCM()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    const fechaInicio = moment(primerDiaMostrado).subtract(1, "d");
    const ultimoDiaMostrado = getFirstSundayFromLDOCM()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    dispatch(
      controller.getReservasByLocalThunk(
        null,
        match.params.organizacion,
        moment(fechaInicio).format("YYYY-MM-DD HH:mm:ss"),
        ultimoDiaMostrado
      )
    );
    setInicio(moment(primerDiaMostrado).format("YYYY-MM-DD"));
    setFin(moment(ultimoDiaMostrado).format("YYYY-MM-DD"));
    dispatch(controllerLocal.localByIdThunk(match.params.organizacion));
  }, []);

  // Gets first sunday from last day of current month, including that day.
  const getFirstSundayFromLDOCM = () => {
    const sundayISO = 7;
    const lastDayOfCurrentMonth = moment().endOf("month");

    // isoWeekday(weekday) sets the weekday for a given date.
    // Gives as a result the date of that weekday in the same
    // week of the original date (lastDayOfMonth).
    const firstSunday = lastDayOfCurrentMonth.clone().isoWeekday(sundayISO);

    return firstSunday;
  };

  // Gets first monday before first day of current month, including that day.
  const getFirstMondayBeforeFDOCM = () => {
    const mondayISO = 1;
    const firstDayOfCurrentMonth = moment().startOf("month");
    const firstMonday = firstDayOfCurrentMonth.clone().isoWeekday(mondayISO);
    return firstMonday;
  };

  // Parsea rango devuelto por big-calendar.
  // Dependiendo del rango elegido,
  // la librería puede devolver un array
  // o un objeto.
  const getFechasFromCalendarRange = (range) => {
    if (Array.isArray(range)) {
      if (range.length > 1) {
        // Usuario eligió 'Semana'

        const inicio = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
        const fin = moment(range[range.length - 1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        return {
          inicio,
          fin,
        };
      }

      // Usuario eligió 'Día'

      const inicio = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
      const fin = moment(range[0])
        .add(1, "days")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      return {
        inicio,
        fin,
      };
    }

    // Usuario eligió 'Agenda' o 'Mes'

    return {
      inicio: moment(range.start).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      fin: moment(range.end).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    };
  };

  // big-calendar ejecuta cada vez que se da clic
  // en uno de los tipos de rangos
  // (mes, semana, dia, etc.).
  // No lo ejecuta al montar el componente.
  const getReservasForRange = (range) => {
    const fechas = getFechasFromCalendarRange(range);

    const inicioFecha = moment(fechas.inicio)
      .subtract(1, "d")
      .format("YYYY-MM-DD");
    const finFecha = moment(fechas.fin).format("YYYY-MM-DD");
    setInicio(inicioFecha);
    setFin(finFecha);

    if (currentProfesional && currentServicio) {
      dispatch(
        controller.getReservasByLocalThunk(
          null,
          match.params.organizacion,
          inicioFecha,
          fechas.fin,
          null,
          null,
          profesional,
          servicio
        )
      );
      dispatch(
        controller.getHorariosEntreFechasThunk(
          inicioFecha,
          finFecha,
          profesional,
          servicio
        )
      );
    } else if (currentServicio) {
      dispatch(
        controller.getReservasByLocalThunk(
          null,
          match.params.organizacion,
          inicioFecha,
          fechas.fin,
          null,
          null,
          null,
          servicio
        )
      );
      dispatch(
        controller.getAmbientesEntreFechasThunk(inicioFecha, finFecha, servicio)
      );
    } else {
      dispatch(
        controller.getReservasByLocalThunk(
          null,
          match.params.organizacion,
          inicioFecha,
          fechas.fin
        )
      );
    }
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    let style = {
      // backgroundColor: event.resource.profesional.color ? event.resource.profesional.color : '#ff0000',
      // borderRadius: "0px",
      // opacity: 0.8,
      // color: "black",
      // border: "0px",
      // display: "block",
    };

    if (
      local &&
      event?.resource?.detalles?.foreignKey &&
      local.profesionales[event.resource.detalles.foreignKey] &&
      local.profesionales[event.resource.detalles.foreignKey].color &&
      conceptoPintar === "profesional"
    ) {
      style.backgroundColor =
        local.profesionales[event.resource.detalles.foreignKey].color;
    } else if (
      local &&
      event?.resource?.detalles?.servicioId &&
      conceptoPintar === "servicio"
    ) {
      const servicio = local.servicios.filter(
        (elem) => elem.id === event?.resource?.detalles?.servicioId
      );
      if (servicio && servicio[0] && servicio[0].color) {
        style.backgroundColor = servicio[0].color;
      }
    } else if (event.resource.ausencia) {
      style.backgroundColor = "#c92f1e";
    } else if (event.resource.cantidadDisponible) {
      style.backgroundColor = "#35c456";
    }

    return {
      style: style,
    };
  };

  const getDateUtcWithHour = (fecha) => {
    const day = fecha
      ? moment(fecha).utc().format("YYYY-MM-DD HH:mm")
      : moment().utc().format("YYYY-MM-DD HH:mm");
    return day;
  };

  const getDateUtc = (fecha) => {
    const day = fecha
      ? moment(fecha).utc().format("YYYY-MM-DD")
      : moment().utc().format("YYYY-MM-DD");
    return day;
  };

  useEffect(() => {
    const data = modelHorarios?.data?.data;
    const error = modelHorarios?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.horariosEntreFechasDuck.actions.clear());
    }
    if (data) {
      const diasDisponibles = Object.values(data.data);
      let arrayFinal = [];

      diasDisponibles.map((row) => {
        const array = [...row];
        arrayFinal = arrayFinal.concat(array);
      });

      const result = arrayFinal.map((row) => {
        const title = row.ausencia
          ? `${row.hora} - AUSENTE`
          : `${row.hora} - ${currentServicio.label} - ${currentProfesional.nombre}`;
        const start = getDateUtcWithHour(row.ts);
        const end = getDateUtcWithHour(row.tsFin);
        const reg = {
          title,
          start: moment(start).utc().toDate(),
          end: moment(end).utc().toDate(),
          allDay: false,
          resource: row,
        };

        return reg;
      });

      setEventosDisponibles(result);
      dispatch(controller.horariosEntreFechasDuck.actions.clear());
      console.log('de vuelta', moment().format('YYYY-MM-DD HH:mm:ss'))
    }
  }, [modelHorarios]);

  const filtrar = () => {
    if (!profesional || !servicio) {
      return alert("Por favor complete los filtros");
    }

    const profesionalOption = profesionalesOptions.filter(
      (elem) => elem.value === profesional
    );
    const servicioOption = serviciosOptions.filter(
      (elem) => elem.value === servicio
    );

    const subcategoriaOption = serviciosPadreOptions.filter(
      (elem) => elem.value === servicioPadre
    );
    setCurrentProfesional(
      profesionalOption && profesionalOption[0] ? profesionalOption[0] : null
    );
    setCurrentServicio(
      servicioOption && servicioOption[0] ? servicioOption[0] : null
    );

    setCurrentSubcategoria(
      subcategoriaOption && subcategoriaOption[0] ? subcategoriaOption[0] : null
    );

    dispatch(
      controller.getReservasByLocalThunk(
        null,
        match.params.organizacion,
        inicio,
        fin,
        null,
        null,
        profesional,
        servicio
      )
    );
    console.log('enviando', moment().format('YYYY-MM-DD HH:mm:ss'))
    dispatch(
      controller.getHorariosEntreFechasThunk(inicio, fin, profesional, servicio)
    );
  };

  const filtrarRestaurante = () => {
    if (!servicio) {
      return alert("Por favor complete los filtros");
    }

    const servicioOption = serviciosOptions.filter(
      (elem) => elem.value === servicio
    );

    const subcategoriaOption = serviciosPadreOptions.filter(
      (elem) => elem.value === servicioPadre
    );

    setCurrentServicio(
      servicioOption && servicioOption[0] ? servicioOption[0] : null
    );

    setCurrentSubcategoria(
      subcategoriaOption && subcategoriaOption[0] ? subcategoriaOption[0] : null
    );
    dispatch(
      controller.getReservasByLocalThunk(
        null,
        match.params.organizacion,
        inicio,
        fin,
        null,
        null,
        null,
        servicio
      )
    );
    dispatch(controller.getAmbientesEntreFechasThunk(inicio, fin, servicio));
  };

  useEffect(() => {
    const data = modelAmbientes?.data?.data;
    const error = modelAmbientes?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.getAmbientesDuck.actions.clear());
    }
    if (data) {
      const diasDisponibles = Object.values(data.data);
      let arrayFinal = [];
      diasDisponibles.map((row) => {
        const array = [...row];
        arrayFinal = arrayFinal.concat(array);
      });

      const result = arrayFinal.map((row) => {
        if (getDateUtc() <= getDateUtc(row.fecha)) {
          const title = `${currentServicio.label} - ${row.nombre}`;
          const start = getDateUtcWithHour(row.fecha);
          const end = getDateUtcWithHour(row.fecha);
          const reg = {
            title,
            start: moment(start).toDate(),
            end: moment(end).toDate(),
            allDay: true,
            resource: row,
          };

          return reg;
        }
      });

      setEventosDisponibles(result);
      dispatch(controller.getAmbientesDuck.actions.clear());
    }
  }, [modelAmbientes]);

  const clearDisponibles = () => {
    setCurrentProfesional(null);
    setCurrentServicio(null);
    setServicioPadre(null);
    setServicio(null);
    setProfesional(null);
    setEventosDisponibles([]);
    dispatch(
      controller.getReservasByLocalThunk(
        null,
        match.params.organizacion,
        inicio,
        fin
      )
    );
  };

  return (
    <Content
      title="Bienvenido"
      browserTitle="Bienvenido a Agendia"
      show={false}
    >
      <Col md="12">
        {actualRol === "superadmin" || actualRol === "admin" ? (
          <Box title={"Filtrar disponibilidades"}>
            <Col md="12">
              <Col md="3">
                <SelectInput
                  value={servicioPadre}
                  setValue={setServicioPadre}
                  label="Subcategoria"
                  options={serviciosPadreOptions}
                />
              </Col>
              <Col md="3">
                <SelectInput
                  value={servicio}
                  setValue={setServicio}
                  label="Servicio"
                  options={serviciosOptions}
                />
              </Col>
              {local && local.categoriaId !== "60f806a5e3e9af972fe85c7a" ? (
                <Col md="3">
                  <SelectInput
                    value={profesional}
                    setValue={setProfesional}
                    label="Profesional"
                    options={profesionalesOptions}
                  />
                </Col>
              ) : null}
              {local && local.categoriaId !== "60f806a5e3e9af972fe85c7a" ? (
                <Col md="3">
                  <div style={{ marginTop: 15 }}>
                    <Button
                      type="primary"
                      text="Filtrar"
                      onClick={() => filtrar()}
                    />
                  </div>
                </Col>
              ) : (
                <Col md="3">
                  <div style={{ marginTop: 15 }}>
                    <Button
                      type="primary"
                      text="Filtrar"
                      onClick={() => filtrarRestaurante()}
                    />
                  </div>
                </Col>
              )}

              {currentProfesional && currentServicio ? (
                <Col md="12">
                  <div style={{ marginTop: 15 }}>
                    <Button
                      type="primary"
                      text="Mostrar solo reservas"
                      onClick={() => clearDisponibles()}
                    />
                  </div>
                </Col>
              ) : null}
            </Col>
          </Box>
        ) : null}
        <Box title={"Lista"}>
          {actualRol === "superadmin" || actualRol === "admin" ? (
            <Col md="1.5" style={{ float: "right" }}>
              <div>
                <a
                  id="id-copiar"
                  type="primary"
                  text={copyIcon}
                  style={{ cursor: 'pointer' }}
                  data-toggle="tooltip" title="Usa este link para exportar tu calendario a otros servicios como Google Calendar, Outlook, Samsung Calendar, etc."
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${process.env.REACT_APP_API_URL}/getIcsFile/${local.id}`
                    )
                    setCopyIcon("✓ Copiar URL para feed");
                  }}>{copyIcon}</a>
              </div>
            </Col>) : null}
          {actualRol === "superadmin" || actualRol === "admin" ? (
            <Col md="12">
              <Col md="3">
                <SelectInput
                  value={conceptoPintar}
                  setValue={setConceptoPintar}
                  label="Mostrar colores por:"
                  options={conceptoAPintarOptions}
                />
              </Col>

            </Col>
          ) : null}
          <Col md="12" style={{ textAlign: "center" }}>
            <LoaderCalendario
              loading={modelEventos.loading || modelHorarios.loading || modelLocal.loading}
            />
          </Col>
          <Col
            md="12"
            style={{
              display:
                modelEventos.loading || modelHorarios.loading
                  ? "none"
                  : "block",
            }}
          >
            <div style={{ marginTop: 20 }}>
              <Calendar
                localizer={localizer}
                events={[...eventos, ...eventosDisponibles]}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 2000 }}
                onSelectEvent={(event) => {
                  if (event.resource.ausencia) {
                    return alert("Horario no disponible por ausencia");
                  }

                  if (
                    event.resource.tsFin ||
                    (event.resource.cantidadDisponible &&
                      event.resource.ambienteId)
                  ) {
                    if (local.categoriaId === "60f806a5e3e9af972fe85c7a") {
                      localStorage.setItem(
                        "horarioSelected",
                        JSON.stringify(event.resource)
                      );
                      localStorage.setItem(
                        "subcategoria",
                        JSON.stringify(currentSubcategoria)
                      );
                      localStorage.setItem(
                        "servicio",
                        JSON.stringify(currentServicio)
                      );

                      history.push(
                        `/crearReservaRestaurante/${match.params.organizacion}`
                      );
                    } else {
                      localStorage.setItem(
                        "horarioSelected",
                        JSON.stringify(event.resource)
                      );
                      localStorage.setItem(
                        "subcategoria",
                        JSON.stringify(currentSubcategoria)
                      );
                      localStorage.setItem(
                        "servicio",
                        JSON.stringify(currentServicio)
                      );
                      localStorage.setItem(
                        "profesional",
                        JSON.stringify(currentProfesional)
                      );
                      history.push(
                        `/crearReserva/${match.params.organizacion}`
                      );
                    }
                  } else if (event.resource.detalles) {
                    history.push(`/reserva/${event.resource._id}`);
                  }
                }}
                messages={{
                  next: "Sig",
                  previous: "Ant",
                  today: "Hoy",
                  month: "Mes",
                  week: "Semana",
                  day: "Día",
                }}
                onRangeChange={getReservasForRange}
                eventPropGetter={eventStyleGetter}
              />
            </div>
          </Col>
        </Box>
      </Col>
    </Content>
  );
}

export default Calendario;
